module.exports = __webpack_public_path__ + "img/tom_parling.432ee89d.jpg";